export default __webpack_public_path__ + "./images/features-4.webp";